import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import { next, back, submitDoctorForm } from "../../actions/index";
import { stateProps } from "../../types";
import ButtonUnstyled, { ButtonUnstyledProps } from "@mui/base/ButtonUnstyled";
import { styled } from "@mui/system";
import Divider from "@mui/material/Divider";
import { checkCurrentFieldStatus } from "../../utils/checkCurrentFieldStatus";

const NextButton = styled("button")`
  background-color: #007fff;
  width: 185px;
  height: 46px;
  padding: 15px 35px;
  border-radius: 4px;
  color: #fff;
  font-weight: 900;
  font-family: Avenir;
  font-size: 15px;
  line-height: 9px;
  transition: all 200ms ease;
  cursor: pointer;
  box-shadow: 0 4px 20px 0 rgba(61, 71, 82, 0.1), 0 0 0 0 rgba(0, 127, 255, 0);
  border: none;
  '&.Mui-disabled': {
    background-color: "#333333",
  },
`;

const BackButton = styled("button")`
  background-color: #ffffff;
  padding: 15px 35px;
  padding-left: 3px;
  border-radius: 10px;
  color: #333333;
  font-weight: 550;
  font-family: Avenir;
  font-size: 18px;
  line-height: 22px;
  transition: all 200ms ease;
  cursor: pointer;
  border: none;
`;

function ButtonNext(props: ButtonUnstyledProps) {
  return <ButtonUnstyled {...props} component={NextButton} />;
}

function ButtonBack(props: ButtonUnstyledProps) {
  return <ButtonUnstyled {...props} component={BackButton} />;
}
const Footer: React.FC = () => {
  const dispatch = useDispatch();

  const state = useSelector(
    (state: { router: History; doctorInfo: stateProps }) => state.doctorInfo
  );

  const { step, termsAndConditions } = state;

  const isEmptyCurrentField = checkCurrentFieldStatus(step, state);

  const forwardNavigation = () => {
    dispatch(next());
  };

  const backwardNavigation = () => {
    dispatch(back());
  };

  const onSubmit = () => {
    dispatch(next());
    if (termsAndConditions === "I accept") dispatch(submitDoctorForm(state));
  };

  return (
    <Box
      sx={{
        pl: { xs: "10px", sm: "50px", md: "100px" },
        mt: "28px",
        mb: 3,
        pr: { xs: "10px", sm: "50px", md: "100px" },
        maxWidth: { xs: "100vw", sm: "100vw", md: "100vw" },
        maxHeight: { xs: "100vh", sm: "100vh", md: "100vh" },
        display: "block",
      }}
    >
      <Box sx={{ pb: 2 }}>
        <Divider />
      </Box>
      <div>
        <Box display="flex" justifyContent="space-between">
          <ButtonBack onClick={backwardNavigation}>Back</ButtonBack>
          {step === 26 ? (
            <ButtonNext
              onClick={onSubmit}
              disabled={isEmptyCurrentField}
              style={
                isEmptyCurrentField
                  ? { backgroundColor: "rgb(0 127 254 / 50%)" }
                  : { backgroundColor: "#007fff" }
              }
            >
              Submit Form
            </ButtonNext>
          ) : (
            <ButtonNext
              onClick={forwardNavigation}
              disabled={isEmptyCurrentField}
              style={
                isEmptyCurrentField
                  ? { backgroundColor: "rgb(0 127 254 / 50%)" }
                  : { backgroundColor: "#007fff" }
              }
            >
              Next
            </ButtonNext>
          )}
        </Box>
      </div>
    </Box>
  );
};

export default Footer;
